import { useState, useEffect } from 'react';
import api from "../lib/axios/index.js";
import { message } from 'antd';

const useFetchBasketRecommendations = () => {
    const [basketRecommendations, setNewBasketRecommendations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNewBasketRecommendations = async () => {
            try {
                const response = await api.get('/baskets');
                if (response.status !== 200) {
                    message.error("API Error");
                    return;
                }

                const data = await response.data;

                setNewBasketRecommendations(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchNewBasketRecommendations();
    }, []);

    return { basketRecommendations, loading, error };
};

export default useFetchBasketRecommendations;